import { listCourses } from '@/api/OmdCourses/courses';
import { listWorkssslu } from '@/api/Works/works';
import OmdAboutUs from '@/views/main/OmdAboutUs.vue';
import OmdContactUs from '@/views/main/OmdContactUs.vue';
import OmdService from '@/views/main/OmdService.vue';
import WorkComments from '@/views/main/WorkComments.vue';
import{FROM_SOURCE} from '@/constants/fromSource';

export default {
    components: {
        OmdAboutUs,
        OmdService,
        OmdContactUs,
        WorkComments
    },
    data() {
        return {
            mian:'首页',
            active:0,
            imageUrl: [],
            loginForm: {
                username: '',
                password: ''
            },
            que: {
                pageNum: 1,
                pageSize: 12,
                category:"",
               
            },
            course: [],
            total: 0,
            color: false,
            loadedImages: 0,
            isScrollAtBottom: false,
            activeIndex: '1', // 默认选中美妆（index=1），后续会动态更新
        }
    },
    
mounted() {
     this.imag("美妆"); // 调用imag方法，确保activeIndex被正确应用
},

   


       computed: {
  // 限制显示的图片数量（最多3行x4列=12个）
  visibleImages() {
    return this.imageUrl.slice(0, 12);
  }

  

},
    
  
    methods: {
       
        handleCurrentChange(val){
            this.que.pageNum = val;
             this.imag(this.que.category);
         },

        // defactive(address){
        //     this.active++;
        //      console.log(address);
        //     this.imag('美妆', "武汉");
        // },
        xiangqing(id) {
            // 1. 找到当前作品在专业列表中的索引
                const currentIndex = this.imageUrl.findIndex(item => item.id === id);
                // 2. 存储来源标识、列表、索引到sessionStorage
                sessionStorage.setItem('from', FROM_SOURCE.MAJOR); // 来源：专业页
                sessionStorage.setItem('major_worksList', JSON.stringify(this.imageUrl)); // 专业页的作品列表
                sessionStorage.setItem('major_currentIndex', currentIndex); // 当前作品在专业列表中的索引
                        // 3. 存储当前作品ID（供详情页初始加载）
                sessionStorage.setItem('imageurl', id);
                // 4. 跳转详情页（根据项目路由方式调整，如this.$router.push('/detail')）
                this.mian = '详情'; 
          
        },
        setcourse() {
            listCourses().then(response => {
                this.course = response.rows;
                console.log(this.course)
            })
        },
        setWorkurl() {
            listWorkssslu(this.que).then(response => {
                
                this.imageUrl = response.rows;
               
                this.total = response.total;
                console.log(this.imageUrl)
            })
        },
        handleLogin() {
            this.$router.push('/login')
            window.location.reload();
        },
        getUrl(url) {
            // console.log(process.env.VUE_APP_BASE_API + url)
            // return process.env.VUE_APP_BASE_API + url;
            console.log( url)
            
             return  url;
        },
        imag(category) {
            switch(category){
                case '美妆':
                    this.activeIndex = '1';
                    break;
                case '美发':
                    this.activeIndex = '2';
                    break;
                case '美容':
                    this.activeIndex = '3';
                    break;
                case '美甲':
                    this.activeIndex = '4';
                    break;
            }
            sessionStorage.setItem('lastActiveIndex', this.activeIndex);

                   this.que.category=category;

                   listWorkssslu(this.que).then(response => {
                        // console.log(response.rows.length)
                        if (response.rows.length == 0) {
                            this.$message.error('暂无相关作品');
                            this.que.category='美妆';
                            this.imag('美妆');
                            return;
                        }
                        
                        this.imageUrl = response.rows;
                        this.total = response.total;
                        console.log(this.imageUrl)
                    }).catch(error => {
                        console.error('Error fetching imageUrl:', error);
                    })
               
        }
    },
};